import style from '../style/components/loading.module.scss'
import { Loading as LoadingIcon } from './icon'

interface LoadingProps {
  className?: string
}

const Loading = ({ className = '' }: LoadingProps) => {
  return (
    <div className={style.wrapper + ` ${className}`}>
      <LoadingIcon />
    </div>
  )
}

export default Loading
